import React from 'react'
import { GuildStatus } from '@/utils/users/usersServer'

const GuildStatusContext = React.createContext<GuildStatus | undefined>(undefined)

interface GuildStatusContextProviderProps {
  children: React.ReactNode
  guildStatus?: GuildStatus
}

export const GuildStatusContextProvider: React.FC<GuildStatusContextProviderProps> = ({ guildStatus, children }) => {
  return <GuildStatusContext.Provider value={guildStatus}>{children}</GuildStatusContext.Provider>
}

export const useGuildStatus = () => {
  const context = React.useContext(GuildStatusContext)
  if (!context) {
    throw new Error('useGuildStatus must be used within a GuildStatusContextProvider')
  }

  return context
}

export const useGuildStatusUnguarded = () => {
  return React.useContext(GuildStatusContext)
}
